export default __webpack_public_path__ + "static/media/vishal-pednekar.b0005f03.jpg";